import { Box, Divider, Icon, Typography } from "@mui/material";
import MoneyTriple from 'components/Icons/MoneyTriple';
import { CustomButton } from 'components/roundedbutton/CustomButton';
import useCatchApiError from "hooks/useCatchApiError";
import { useSnackbarCustom } from "hooks/useSnackCustom";
import HeaderOuBannerDependendoDaInterpretacaoH1 from 'layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1';
import { CustomSwitch } from "pages/cadastro-pessoa/CadastroPessoa";
import { useEffect, useState } from "react";
import { ConfiguracoesTitle } from '../Configuracoes.model';
import { ConfiguracaoCaixaDTO } from "./configuracao-caixa.model";
import ConfiguracaoCaixaService from "./configuracao-caixa.service";
import { theme } from "theme";

type Props = {
    onGoBack: () => void;
};

type InitialState = {
    configuracao: ConfiguracaoCaixaDTO | null,
};

const initialState: InitialState = {
    configuracao: null
};

const ConfiguracaoCaixa = (props: Props) => {
    const configuracaoCaixaService = ConfiguracaoCaixaService();
    const { throwErrorMessage } = useCatchApiError();
    const { addSuccess } = useSnackbarCustom();

    const [localState, setLocalState] = useState(initialState);

    useEffect(() => {
        configuracaoCaixaService.getConfiguracao()
            .then(({ data }) => {
                setLocalState(prev => ({ ...prev, configuracao: data }));
            })
            .catch(throwErrorMessage);
        // eslint-disable-next-line
    }, []);

    const handleChangeBloquearFechamento = (checked: boolean) => {
        setLocalState(prev => ({
            ...prev,
            configuracao: prev.configuracao ? {
                ...prev.configuracao,
                bloquearFechamento: checked
            } : null
        }));
    };

    const handleSave = () => {
        if (!localState.configuracao) return;
        configuracaoCaixaService.update(localState.configuracao)
            .then(() => {
                props.onGoBack();

                setTimeout(() => {
                    addSuccess({ message: 'Configuração do caixa atualizada com sucesso' });
                }, 200);
            })
            .catch(throwErrorMessage);
    };

    return (
        <Box
            sx={{
                height: 'calc(100vh - 100px)',
                display: 'grid',
                gridTemplateRows: 'auto auto 1fr auto',
                rowGap: '15px'
            }}
        >
            <HeaderOuBannerDependendoDaInterpretacaoH1
                id='configura-caixa-header'
                customIcon={
                    <MoneyTriple
                        id="configura-caixa-icon"
                        color={theme.palette.text.primary}
                        fontSize=''
                        style={{
                            marginBottom: '5px',
                        }}
                        sx={{
                            transform: 'scale(.35) translateX(-40px)'
                        }}
                    />
                }
                label={ConfiguracoesTitle.CONFIGURACAO_CAIXA}
            />

            <Box>
                <Typography
                    sx={{
                        fontSize: 22,
                        marginBottom: '10px',
                        marginTop: '-15px'
                    }}
                >
                    Definir configurações de fechamento de caixa
                </Typography>
                <Divider />
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    width: '50%',
                    justifyContent: 'space-between',
                }}>
                <Typography
                    sx={{
                        fontSize: 18,
                        color: theme.palette.text.primary
                    }}
                >
                    Bloquear fechamento de caixa quando houver nota(s) pendente?
                </Typography>

                <CustomSwitch
                    id='bloquear-fechamento-input'
                    checked={localState.configuracao?.bloquearFechamento ?? false}
                    onChange={(_, checked) => handleChangeBloquearFechamento(checked)}
                    name="bloquear-fechamento" />
            </Box>

            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <CustomButton
                    sx={{ minWidth: '80px' }}
                    id="voltar-btn"
                    onClick={props.onGoBack}
                    variant="contained"
                    color="error"
                    startIcon={<Icon className='fa-solid fa-arrow-left' />}>
                    Voltar
                </CustomButton>

                <CustomButton
                    sx={{ minWidth: '80px' }}
                    id="salvar-btn"
                    onClick={handleSave}
                    variant="contained"
                    color="success"
                    startIcon={<Icon className='fa-solid fa-check' />}>
                    Salvar
                </CustomButton>

            </Box>

        </Box>
    );
};

export default ConfiguracaoCaixa;
